// pages/Gallery/index.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from '../../styles/components';
import {
    GalleryWrapper,
    GalleryHeader,
    HeaderContent
} from './styles';

const Gallery = () => {
    return (
        <GalleryWrapper>
            <GalleryHeader>
                <HeaderContent>
                    <h1>Photo Gallery</h1>
                    <p>Browse through our collection of memories</p>
                </HeaderContent>
            </GalleryHeader>

            <Container>
                <Outlet />
            </Container>
        </GalleryWrapper>
    );
};

export default Gallery;